import { DateTime } from "luxon";
import { string } from "prop-types";
import { PaginationRequestInterface } from './pagination'
import { GridSortRequest, GridSortModel } from './sort';

export enum RecRegistryCertificateGenerationStatus {
  ok = "ok",
  processingRequired = "processingRequired",
  error = "error",
}

export default class RecRegistryCertificateGeneration {
  id: string
  registeredPersonNumber = 0
  accreditationCodeId: string
  generationYear = 2001
  actionDayImported?: string
  actionDayProcessed?: string
  containsErrors = false

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
  constructor(obj: any) {
    Object.assign(this, obj)
    this.id = obj.id ?? ""
    this.accreditationCodeId = obj.accreditationCode?.id
    this.actionDayImported = obj.actionDayImported?.id
    this.actionDayProcessed = obj.actionDayProcessed?.id
  }

  get processingRequired(): boolean {
    if (!this.actionDayImported) {
      return false
    }
    if (!this.actionDayProcessed) {
      return true
    }

    return this.actionDayProcessed! < this.actionDayImported
  }

  get status(): RecRegistryCertificateGenerationStatus {
    if (this.containsErrors) {
      return RecRegistryCertificateGenerationStatus.error
    }
    if (this.processingRequired) {
      return RecRegistryCertificateGenerationStatus.processingRequired
    }

    return RecRegistryCertificateGenerationStatus.ok
  }
}

// Request

export class RecRegistryCertificateGenerationRequest implements PaginationRequestInterface, GridSortRequest {
  accreditationCodeId?: string
  generationYear?: number
  registeredPersonNumber?: number
  containsErrors?: boolean
  sort?: GridSortModel
  sortDesc?: boolean
  per = 25
  page = 0

  static copy(from: RecRegistryCertificateGenerationRequest): RecRegistryCertificateGenerationRequest {
    const newRequest = new RecRegistryCertificateGenerationRequest()
    Object.assign(newRequest, from)
    return newRequest
  }
}
